import axios from 'axios'

/**
 * @desc Lookup PostCode Zone
 */
export const lookupPostCode = (postCode) =>
  axios.get(`/authenticated/zones/${postCode}`).then((res) => res.data)

/**
 * @desc Lookup URL to open PostCode Zones PDF
 */
export const getPostCodeZonesPDF = () =>
  axios.get('/authenticated/zones/pdf').then((res) => res.data)

/**
 * @desc Upload Supplierlogo
 */
export const uploadLogo = (supplierId, file) => {
  const formData = new FormData()
  formData.append('file', file)

  return axios
    .post(`/authenticated/supplier/${supplierId}/logo`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    .then((res) => res.data)
}

/**
 * @desc Fetch Brands for Supplier
 */
export const getBrandsList = (supplierId) =>
  axios
    .get(`/authenticated/products/brands/supplier/${supplierId}`)
    .then((res) => res.data)

/**
 * @desc Fetch Brands for Supplier
 */
export const getBrandsImages = (supplierId) =>
  axios
    .get(`/authenticated/brand-image?supplierId=${supplierId}`)
    .then((res) => res.data)

/**
 * @desc Add or Update Brand Logo
 */
export const uploadBrandLogo = (supplierId, brandName, position, file) => {
  const formData = new FormData()
  formData.append('file', file)
  const encodedBrandName = encodeURIComponent(brandName)
  return axios
    .post(
      `/authenticated/brand-image?supplierId=${supplierId}&brand=${encodedBrandName}&position=${position}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )
    .then((res) => res.data)
}

/**
 * @desc Delete Brand Logo
 */
export const deleteBrandLogo = (brandImageId) =>
  axios
    .delete(`/authenticated/brand-image/${brandImageId}`)
    .then((res) => res.data)

export const fetchApprovalStatusStatistics = () =>
  axios
    .get(`/authenticated/data-maintenance/approval-status-statistics`)
    .then((res) => res.data)
